import * as React from "react";
const SvgArrowUp2 = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z" /><path fill="none" d="M0 0h24v24H0z" /></svg>;
export { SvgArrowUp2 as ReactComponent };